import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JournalHomeComponent } from './journal-home/journal-home.component';
import { JournalVolumeListingComponent } from './journal-volume-listing/journal-volume-listing.component';
import { ArticleListingComponent } from './articles/article-listing/article-listing.component';
import { ArticleViewPageComponent } from './articles/article-view-page/article-view-page.component';
import { LoadContentComponent } from './load-content/load-content.component';
// import { ContactUsComponent } from '../contact-us/contact-us.component';
// import { FaqListingComponent } from '../faq/view-all-faq/faq-listing.component';
import { EditorialBoardComponent } from '../editorial-board/editorial-board.component';
import { DataResolver } from './load-content/data.resolver';
import { CurrentArticlesComponent } from './current-articles/current-articles.component';
import { VolumeIssueListComponent } from './volume-issue-list/volume-issue-list.component';

const journalRoutes: Routes = [
    //   {
    //     path: 'journal/:journal_id',
    //     component: AppHeaderComponent, // Your header component
    //     children: [
    //       {
    //         path: '',
    //         component: JournalHomeComponent, // Your content component
    //       },
    //       // Add the empty path route explicitly to display the home component
    //       {
    //         path: 'home',
    //         component: JournalHomeComponent,
    //       },
    //     ],
    // },
    // {
    //     path: '',
    //     component: JournalListingComponent,

    // },
    {
        path: '',
        component: JournalHomeComponent,
    },
    {
        path: 'volumes',
        // component: JournalVolumeListingComponent
        component:VolumeIssueListComponent
    },
    {
        path: 'current-articles',
        // component: JournalVolumeListingComponent
        component: CurrentArticlesComponent
    },
    {
        path : 'thematic-collections',
        component: JournalVolumeListingComponent
    },
    {
        path : 'thematic-collections/:volume_id',
        component: JournalVolumeListingComponent
    },
    {
        path: 'volumes/:volume_id',
        component: JournalVolumeListingComponent
    },
    {
        path: 'current-articles/articles',
        component: ArticleListingComponent
    },
  
    {
        path: 'current-articles/articles/:volume_id/:issue_id',
        component: ArticleListingComponent
    },
    {
        path: 'current-articles/articles/:volume_id/:issue_id/page/:page_no',
        component: ArticleListingComponent
    },
    //for regular articles
    {
        path: 'regular-articles/articles',
        component: ArticleListingComponent
    },
    {
        path: 'regular-articles/articles/:volume_id/:issue_id',
        component: ArticleListingComponent
    },
    {
        path: 'regular-articles/articles/:volume_id/:issue_id/page/:page_no',
        component: ArticleListingComponent
    },
    //for thematic articles
    {
        path: 'thematic-collections/articles',
        component: ArticleListingComponent
    },
    {
        path: 'supplementary-collections/articles/:volume_id',
        component: ArticleListingComponent
    },
    {
        path: 'supplementary-collections/articles/:volume_id',
        component: ArticleListingComponent
    },
    {
        path: 'supplementary-collections/articles/:volume_id/:issue_id/page/:page_no',
        component: ArticleListingComponent
    },
    {
        path: 'thematic-collections/articles/:volume_id',
        component: ArticleListingComponent
    },
    {
        path: 'thematic-collections/articles/:volume_id/:issue_id',
        component: ArticleListingComponent
    },
    {
        path: 'thematic-collections/articles/:volume_id/:issue_id/:thematic_identifier',
        component: ArticleListingComponent
    },
    {
        path: 'thematic-collections/articles/:volume_id/:issue_id/:thematic_identifier/page/:page_no',
        component: ArticleListingComponent
    },
    {
        path: 'articles',
        component: ArticleListingComponent
    },
    {
        path: 'articles/page/:page_no',//for all articles
        component: ArticleListingComponent
    },
    {
        path: 'articles/fasttrack/page/:page_no',
        component: ArticleListingComponent
    },
    {
        path: 'articles/:volume_id/:issue_id/page/:page_no',
        component: ArticleListingComponent
    },  
    {
        path: 'articles/:volume_id/:issue_id',
        component: ArticleListingComponent
    }, {
        path: 'current-articles/page/:page_no',
        component: ArticleListingComponent
    },{
        path: 'articles',
        component: ArticleListingComponent
    },
    {
        path: 'articles/:volume_id/:issue_id/:article_id',
        component: ArticleViewPageComponent
    },
    {
        path: 'articles/fasttrack/:volume_id/:issue_id/:article_id',
        component: ArticleViewPageComponent
    },
    {
        path: 'articles/:volume_id/:issue_id/:article_id/:preview_mode',
        component: ArticleViewPageComponent
    },
    {
        path: 'content/:page_name_id',
        component: LoadContentComponent
    },
    {
        path: 'content/:page_name_id/:token/:languageCode',
        component: LoadContentComponent,
        resolve: {
            contentData: DataResolver
          }
    },
    // {
    //     path: 'contact',
    //     component: ContactUsComponent
    // },
    // {
    //     path: 'faq',
    //     component: FaqListingComponent
    // },
    {
        path: 'editorial-board',
        component: EditorialBoardComponent
    },
    {
        path:'content/download/thematic-collection-proposal-form',
        component: LoadContentComponent
    }
  
]
@NgModule({
    imports: [RouterModule.forChild(journalRoutes)],
    exports: [RouterModule]
})
export class JournalRoutingModule { }
